import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { useSEO } from "@/lib/seo";
import { useSettings } from "@/lib/hooks";
import { mediaUrl } from "@/lib/api";
import { ParallaxImage, Reveal, Stagger, StaggerItem } from "@/components/site/Motion";
import { NetworkSection } from "@/components/site/NetworkSection";

export default function About() {
  const { t, lang } = useLang();
  const { data: s } = useSettings();
  useSEO({
    title: lang === "fr" ? "À propos — Palissiere Motor Group, courtier automobile international" : "About — Palissiere Motor Group, international automotive broker",
    description: t("ab_p1"), lang,
  });
  return (
    <div className="bg-[#070809]">
      <section className="relative h-[60svh] min-h-[420px] overflow-hidden">
        {s && <ParallaxImage src={mediaUrl(s.visuals?.about)} alt="" className="absolute inset-0" strength={8} />}
        <div className="absolute inset-0 bg-gradient-to-t from-[#070809] via-[#070809]/30 to-[#070809]/40" />
        <div className="container-x relative flex h-full flex-col justify-end pb-14">
          <p className="eyebrow mb-5">{t("about_eyebrow")}</p>
          <h1 className="display text-4xl sm:text-5xl lg:text-6xl" data-testid="about-title">{t("ab_title")}</h1>
        </div>
      </section>
      <section className="section light">
        <div className="container-x grid gap-12 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <p className="display-tight text-xl leading-snug text-[#0e1013] sm:text-2xl lg:text-3xl">{t("ab_p1")}</p>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-[#4b5563]">{t("ab_p2")}</p>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-[#4b5563]">{t("ab_p3")}</p>
          </Reveal>
          <Stagger className="lg:col-span-4 lg:col-start-9 lg:pt-4">
            {["ab_1", "ab_2", "ab_3", "ab_4"].map((k, i) => (
              <StaggerItem key={k} className="flex items-center gap-5 border-t border-[#0e1013]/15 py-5 last:border-b">
                <span className="mono text-[0.6rem] text-[#5b6572]">0{i + 1}</span>
                <span className="display-tight text-lg text-[#0e1013]">{t(k)}</span>
              </StaggerItem>
            ))}
            <Link to="/contact" data-testid="about-contact-cta" className="btn btn-dark mt-10">{t("nav_contact")} <ArrowRight size={14} /></Link>
          </Stagger>
        </div>
      </section>
      <NetworkSection />
    </div>
  );
}
